import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { GridTableParametersService } from './../../../../template/gridTemplate/gridTableParameters.service';
import { FormularService } from 'src/app/Services/formular.service';
import { AuthentService, AuthenticationRole } from 'src/app/Services/authent.service';
import { getLocaleDateFormat } from '@angular/common';
import { MapConfig } from '../new-request-model';
import { MatStepper } from '@angular/material/stepper';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';

declare function frameValidate(): any;

@Component({
  selector: 'app-map-page',
  templateUrl: './map-page.component.html',
  styleUrls: ['./map-page.component.css']
})
export class MapPageComponent implements OnInit {
  @Input() public childFormInput: FormGroup;
  @Input() public OverviewForm;
  @Input() public CoordinateSearchFormGroup;
  @Output() public submitFormular = new EventEmitter();
  @Input() public stepper;

  resourceDefinition;
  requestUser;
  showLoading = true;
  mapConfig = MapConfig;
  routerString;

  constructor(
    private shareData: SharingDataService,
    public grid: GridTableParametersService,
    public formularService: FormularService,
    public authService: AuthentService,
    private errorHandlingService: ErrorHandlingService,
    public router: Router,
    ) {}

  mapFormular = [
    {formControlName : "SCALE",                           listOfValues: new Array(), required: true,    readonly : false,   datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "getReadOnlyData",    title: "cptn_MapProperties"},
    {formControlName : "FORMAT",                          listOfValues: new Array(), required: true,    readonly : false,   datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: "getReadOnlyData",    title: null},
    {formControlName : "PLOT_FORMAT", newRow: true,       autocomplete: null,        required: false,   readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: null,                   title: null},
    {formControlName : "MAX_SHAPE_SIZE",                  autocomplete: null,        required: false,   readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: null,                   title: null},
    {formControlName : "MAX_NO_MAPSHEET_REQ",             autocomplete: null,        required: false,   readonly : true,    datepicker: false,   datepickerType: null,     datepickerMax : null,     datepickerMin : null,         textArea: false,  function: null,                   title: null},
  ]

  columns = [
    { name: "G3E_ELNO", visible: true, enableFilter: false, enableOrderBy: false, export: true, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_EXPORT_SERVICE", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
  ];

  outputFormatGridData = new Array();

  action(action){
    this[action]();
  }

  onSubmit() {
    this.submitFormular.emit();
  }

  resetFormular(){
    this.mapFormular.forEach(element => {
      if(element.formControlName == "SCALE"){ element.function = null}
      if(element.formControlName == "FORMAT"){ element.function = null}
    });
    this.childFormInput.reset();
    this.mapFormular.forEach(element => {
      if(element.formControlName == "SCALE"){ element.function = "getReadOnlyData"}
      if(element.formControlName == "FORMAT"){ element.function = "getReadOnlyData"}
    });
  }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);

    if(this.router.url.indexOf("?")>0){
      this.routerString = this.router.url.substr(0, this.router.url.indexOf("?"));
    } else {
      this.routerString = this.router.url;
    }

    if(this.routerString != '/gipReqMan'){
      this.childFormInput.reset();
      if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.ExternalUser || this.authService.currentUser().ROLE == AuthenticationRole.Public) {
        this.shareData.currentUser.subscribe(data => {
          this.requestUser = data;
          if(this.requestUser != null){
            this.getData();
          }
        })
      }
      if (this.authService.currentUser().ROLE == AuthenticationRole.InternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.InternalUser) {
        this.shareData.currentRequestUser.subscribe(data => {
          this.requestUser = data;
          if(this.requestUser != null){
            this.resetFormular();
            this.getData();
          }
        })
      }
    } else {

      if(this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "1" || this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "2" || this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "4"){
        this.mapFormular.forEach(element => {
          if(element.formControlName != "RelodMapCommand"){
            element.function = null;
            element.readonly = true;
          }
        });
        this.shareData.currentRequestUser.subscribe(data => {
          this.requestUser = data;
          this.getReadOnlyData();
        })
      } else {
        this.shareData.currentRequestUser.subscribe(data => {
          this.requestUser = data;
          this.getData();
        })
      }
    }
  }

  getGridData(){
    var urls = [
      `Admin/MS_PRINTERS_CONTRACT?$filter=CONTRACT_ID eq ${this.requestUser.CONTRACT}&$orderby=G3E_ELNO`,
    ];

    this.formularService.getData(urls, (data) => {
      this.outputFormatGridData = data[0];
    });
  }

  getData() {
    this.getGridData();
    this.childFormInput.controls.CONTRACT_ID.setValue(this.requestUser.CONTRACT);
    var urls = [
      `admin/MS_SCALE?$filter=CONTRACT_ID eq ${this.requestUser.CONTRACT}&$orderby=ORDINAL`,
      `admin/MS_FORMAT_CONTRACT?$filter=CONTRACT_ID eq ${this.requestUser.CONTRACT}&$orderby=ORDINAL`
    ];

    this.formularService.getData(urls, (data) => {
      var scales = new Array();
      data[0].forEach(element => {
        scales.push(element.SCALE)
      });
      this.mapFormular.forEach(element => {
        if(element.formControlName == "SCALE"){
          element.listOfValues = [...scales];
          if(this.childFormInput.value.SCALE == null){
            this.childFormInput.controls.SCALE.setValue(element.listOfValues[0])
          }
        }
      });

      var formats = new Array();
      data[1].forEach(element => {
        formats.push(element.USERNAME)
      });
      this.mapFormular.forEach(element => {
        if(element.formControlName == "FORMAT"){
          element.listOfValues = [...formats];
          if(this.childFormInput.value.FORMAT == null){
          this.childFormInput.controls.FORMAT.setValue(element.listOfValues[0])
          }
        }
      });
      this.getReadOnlyData();
      this.showLoading = false;
    });
  }

  sendModel(model){
    this.childFormInput = model;
  }

  mapValidator(){
    if(frameValidate() == ""){
      this.childFormInput.controls.MapValidator.setValue("true");
      this.stepper.next();
    } else {
      this.errorHandlingService.showError(frameValidate(), undefined);
    }
  }

  getReadOnlyData() {
    this.getGridData();
    if (this.childFormInput.value.SCALE != null && this.childFormInput.value.FORMAT != null) {
      this.showLoading = true;
      var urls = [
        `admin/V_MS_PRINTFORMAT?$filter=CONTRACT_ID eq ${this.requestUser.CONTRACT} and SCALE eq ${this.childFormInput.value.SCALE} and FORMAT eq '${this.childFormInput.value.FORMAT}'`,
        `admin/MS_CONTRACT?$filter=ID eq ${this.requestUser.CONTRACT}`
      ];

      this.formularService.getData(urls, (data) => {
        try{
          this.childFormInput.controls.PLOT_FORMAT.setValue(data[0][0].PLOT_FORMAT);

          this.childFormInput.controls.MAX_SHAPE_SIZE.setValue(data[1][0].MAX_SHAPE_SIZE);
          this.mapConfig.maxShapeSize = data[1][0].MAX_SHAPE_SIZE;
          this.childFormInput.controls.MAX_NO_MAPSHEET_REQ.setValue(data[1][0].MAX_NO_MAPSHEET_REQ);
          this.mapConfig.maxMapSheet = data[1][0].MAX_NO_MAPSHEET_REQ;
          this.onSubmit();
        }
        catch{}
        this.showLoading = false;
      });
    }
  }

  close(){
    console.log(this.OverviewForm)
    this.formularService.postData(`plot/closeplot/${this.OverviewForm.value.G3E_FID}`, null, data => {
      this.errorHandlingService.showSuccess(undefined, undefined);
      this.router.navigate(['/gipReqManForm'], { queryParams: { g3e_fid: this.OverviewForm.value.G3E_FID }});
    })
  }
}